// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

type Props = {|
  logoSrc: ?string,
  fallbackText: ?string,
|};

export function MerchantLogoDisplay({ logoSrc, fallbackText }: Props): Node {
  if (!logoSrc) {
    return <FallbackText>{fallbackText}</FallbackText>;
  }

  return (
    <Root>
      <LogoImage src={logoSrc} alt={fallbackText} />
    </Root>
  );
}

const Root = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 32px 16px;
`;

const LogoImage = styled.img`
  max-height: 100px;
  max-width: 100%;
  margin: 0 auto;
`;

const FallbackText = styled.div`
  color: ${props => props.theme.colors.secondary(30)};
  font-size: 1.5em;
  font-weight: 500;
  text-align: center;
  padding: 16px;
`;
